(function () {
  'use strict';

  var root = document.getElementById('snd-root');
  var modal = document.getElementById('snd-modal');
  var card = document.getElementById('snd-card');
  var copyBtn = document.getElementById('snd-copy');
  var closeBtn = document.getElementById('snd-close');
  var figure = document.getElementById('snd-figure');
  if (!root || !modal || !card || !copyBtn) return;

  var CODE = root.dataset.code || 'Sondos';
  var delayMs = Math.max(0, Number(root.dataset.delay || 20) * 1000);
  var hideHours = Math.max(1, Number(root.dataset.hideHours || 1));
  var hideForMs = hideHours * 60 * 60 * 1000;
  var storageKey = 'sondos_promo_popup_welcome_' + String(CODE).toLowerCase();
  // The figure and the light title weight start loading this long before the card opens.
  var WARM_LEAD_MS = 4000;
  // If they are still not in by open time, the card waits at most this long for them.
  var WARM_WAIT_MS = 1200;
  var opened = false;
  var warmed = false;
  var delayTimer;
  var warmTimer;
  var copyReset;
  var returnFocus;
  var hideTimer;

  function otherDialogOpen() {
    return Array.from(document.querySelectorAll('menu-drawer details[open], header-drawer details[open], details-modal details[open], dialog[open], .quick-add-modal[open], .cart-drawer.active, cart-notification.active, [aria-modal="true"]:not(#snd-modal):not([hidden])')).some(function (el) {
        return !el.closest('details:not([open])') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
      });
  }

  function getLastSeen() {
    try {
      return Number(window.localStorage.getItem(storageKey) || 0);
    } catch (error) {
      return 0;
    }
  }

  function rememberSeen() {
    try {
      window.localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {
      // Private browsing can disable storage; the popup still remains usable.
    }
  }

  function shouldShow() {
    var lastSeen = getLastSeen();
    return !lastSeen || Date.now() - lastSeen >= hideForMs;
  }

  // Zero bytes at page load: the figure gets its src here, and the Almarai 300
  // face (declared in sondos-global.css, unused above the fold) is fetched now
  // so the title does not swap weight in front of her.
  function warm() {
    if (warmed) return;
    warmed = true;
    if (figure && !figure.getAttribute('src') && figure.dataset.src) figure.src = figure.dataset.src;
    if (document.fonts && document.fonts.load) document.fonts.load('300 34px Almarai', 'أهلًا').catch(function () {});
  }

  function whenWarm(callback) {
    warm();
    var waits = [];
    if (figure && figure.decode) waits.push(figure.decode().catch(function () {}));
    if (document.fonts && document.fonts.load) waits.push(document.fonts.load('300 34px Almarai', 'أهلًا').catch(function () {}));
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      callback();
    }
    Promise.all(waits).then(finish);
    window.setTimeout(finish, WARM_WAIT_MS);
  }

  function removeTriggers() {
    window.clearTimeout(delayTimer);
    window.clearTimeout(warmTimer);
  }

  function open() {
    window.clearTimeout(hideTimer);
    returnFocus = document.activeElement;
    rememberSeen();
    modal.style.display = 'flex';
    void modal.offsetWidth;
    modal.classList.add('show');
    // Focus the dialog itself, not ✕: focusing ✕ painted its pink focus ring on every open,
    // which read as a pink border round the close button. Tab still reaches ✕ first.
    if (typeof trapFocus === 'function') trapFocus(modal, modal);
    else modal.focus({ preventScroll: true });
  }

  function show() {
    if (opened || !shouldShow()) return;
    if (otherDialogOpen()) {
      delayTimer = window.setTimeout(show, 1000);
      return;
    }
    opened = true;
    removeTriggers();
    whenWarm(open);
  }

  function hide() {
    if (!opened) return;
    modal.classList.remove('show');
    rememberSeen();
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
    hideTimer = window.setTimeout(function () {
      modal.style.display = 'none';
      opened = false;
    }, 280);
  }

  function setCopied(on) {
    var label = document.getElementById('snd-code-label');
    var word = document.getElementById('snd-copy-word');
    var status = document.getElementById('snd-status');
    card.classList.toggle('is-copied', on);
    if (label) label.textContent = on ? 'الصقيه عند الدفع' : 'كود الخصم';
    if (word) word.textContent = on ? 'تم النسخ' : 'انسخي الكود';
    if (status) status.textContent = on ? 'تم نسخ الكود، الصقيه عند الدفع' : '';
  }

  function copied() {
    window.clearTimeout(copyReset);
    setCopied(true);
    copyReset = window.setTimeout(function () {
      setCopied(false);
    }, 2400);
  }

  function legacyCopy() {
    var t = document.createElement('textarea');
    t.value = CODE;
    t.setAttribute('readonly', '');
    t.style.cssText = 'position:fixed;top:0;opacity:0';
    document.body.appendChild(t);
    t.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (error) {
      ok = false;
    }
    document.body.removeChild(t);
    return ok;
  }

  // Last resort: select the code on the card so a long-press copies it.
  function selectCode() {
    var value = document.getElementById('snd-code-value');
    var sel = window.getSelection && window.getSelection();
    if (!value || !sel) return;
    var range = document.createRange();
    range.selectNodeContents(value);
    sel.removeAllRanges();
    sel.addRange(range);
  }

  function copy() {
    function fallback() {
      if (legacyCopy()) copied();
      else selectCode();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(CODE).then(copied, fallback);
    } else {
      fallback();
    }
  }

  if (!shouldShow()) return;

  delayTimer = window.setTimeout(show, Math.max(0, delayMs - window.performance.now()));
  warmTimer = window.setTimeout(warm, Math.max(0, delayMs - WARM_LEAD_MS - window.performance.now()));

  if (closeBtn) closeBtn.addEventListener('click', hide);
  copyBtn.addEventListener('click', copy);

  modal.addEventListener('click', function (event) {
    if (event.target === modal) hide();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !modal.classList.contains('show')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    hide();
  }, true);
})();
